import React, { PureComponent } from 'react'
import { Grid, Tooltip, Menu, MenuItem, Select, Stack } from '@mui/material'
import TemplateInstall from '../Template/TemplateInstall'
import ExpiredModal from './Upgrade/ExpiredModal'
import BlockLazy from './MyPage/BlockLazy'
import { WidthProvider, Responsive } from 'react-grid-layout'
import LoadingDefault from '../Elements/Loading/LoadingDefault'
import LoadingPage from '../Elements/Loading/LoadingPage'
import ReactToPrint, { PrintContextConsumer } from 'react-to-print'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/pro-duotone-svg-icons/faPrint'
import { faTimer } from '@fortawesome/pro-duotone-svg-icons/faTimer'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'
import { faExpand } from '@fortawesome/pro-duotone-svg-icons/faExpand'
import { faSquareDashedCirclePlus } from '@fortawesome/pro-duotone-svg-icons/faSquareDashedCirclePlus'
import { faCalendarRange } from '@fortawesome/pro-duotone-svg-icons/faCalendarRange'
import { faEyeSlash } from '@fortawesome/pro-duotone-svg-icons/faEyeSlash'
import { faToggleLargeOn } from '@fortawesome/pro-duotone-svg-icons/faToggleLargeOn'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'

import BlockGeomap from './MyPage/BlockGeomap'
import BlockForm from '../Admin/Pages/Blocks/BlockForm'
import {
    BlockDisplay,
    BlockContainerDisplay,
    CountListBlock,
    CountLinkBlock,
    SumFieldsBlock,
    UserStatisticsBlock,
    DateStatisticsBlock,
    SupersetBlock,
    FunnelBlock,
    PercentageMatchingBlock,
    UserMostActiveStatisticsBlock,
} from '@/feature/admin/Blocks/Components/Display'
import AppDialog from '@/Components/AppDialog/AppDialog'
import {
    StyledButton,
    CompactButton,
} from '@/Components/Elements/StyledComponents/Buttons'

const ResponsiveReactGridLayout = WidthProvider(Responsive)

class MyPage extends PureComponent {
    constructor(props) {
        super(props)
        this.selector = React.createRef()
        this.otherSelector = React.createRef()
        this.observer = null
        this.state = {
            makeReport: false,
            dateFormat: null,
            refreshRate: null,
            expandBlock: null,
            refreshInt: null,
            savingPos: false,
            pos_default: false,
            grayedDateBlocks: '',
            loading: false,
            toggleDrag: false,
            subscriptionExpired: null,
            blocks: [],
            hasMore: true,
            hiddenBlocks: [],
            layout: [],
            isActivated: false,
            presentation: false,
            newBlock: false,
            toggleIcon: true,
            refreshAnchor: null,
            dateAnchor: null,
        }

        this.onLayoutChange = this.onLayoutChange.bind(this)
        this.submitPositions = this.submitPositions.bind(this)
        this.updateData = this.updateData.bind(this)
        this.changeDateBlocks = this.changeDateBlocks.bind(this)
        this.changeRefreshRate = this.changeRefreshRate.bind(this)
        this.hideBlock = this.hideBlock.bind(this)
        this.saveAndRefresh = this.saveAndRefresh.bind(this)
        this.getBlockHeader = this.getBlockHeader.bind(this)
        this.revertHiddenBlocks = this.revertHiddenBlocks.bind(this)
    }

    openRefreshMenu = (e) => {
        this.setState({ refreshAnchor: e.currentTarget })
    }

    openDateMenu = (e) => {
        this.setState({
            dateAnchor: e.currentTarget,
            grayedDateBlocks: ' kedo-block-grayed-dates',
        })
    }

    closeMenus = () => {
        this.setState({
            refreshAnchor: null,
            dateAnchor: null,
            grayedDateBlocks: '',
        })
    }

    handleFullScreenChange = () => {
        if (!document.fullscreenElement && this.isActivated) {
            this.moodPresentation()
            this.presentfullScreen()
        }
    }

    presentfullScreen() {
        if (this.isActivated) {
            document.documentElement.requestFullscreen()
        } else {
            document.exitFullscreen()
        }
    }

    saveAndRefresh(blockId) {
        let api = this.props.kedo.api()
        this.setState({ blockLoading: blockId })
        api.get(api.getMyPageBlockEndpoint(blockId)).then((blockResponse) => {
            let blocks = this.state.blocks
            for (let i = 0; i < blocks.length; i++) {
                if (blocks[i].id === blockId) {
                    blocks[i].settings = blockResponse.data.settings
                }
            }

            this.setState({ blocks: blocks, blockLoading: null }, () =>
                this['blockRef' + blockId].current.fetchData()
            )
        })
    }

    revertHiddenBlocks() {
        this.setState({ loading: true })
        let blocks = [...this.state.blocks]
        let layout = [...this.state.layout]

        this.state.hiddenBlocks.forEach((item) => {
            blocks.push(item.blocks)
            layout.push(item.layout)
        })

        this.setState({
            loading: false,
            layout: layout,
            blocks: blocks,
            hiddenBlocks: [],
        })
    }

    hideBlock(uuid) {
        this.setState({ loading: true })
        let blocks = this.state.blocks.filter((item) => item.uuid !== uuid)
        let layout = this.state.layout.filter((item) => item.i !== uuid)
        let hidden = this.state.hiddenBlocks

        hidden.push({
            layout: this.state.layout.find((item) => item.i === uuid),
            blocks: this.state.blocks.find((item) => item.uuid === uuid),
        })

        this.setState({
            loading: false,
            layout: layout,
            blocks: blocks,
            hiddenBlocks: hidden,
        })
    }

    fetchMyPageBlocks() {
        let api = this.props.kedo.api()
        let environment = this.props.kedo.env().getEnvironment()
        if (!environment) {
            return
        }

        let params = {
            params: {
                dashboard: true,
                environment: environment.id,
                default: this.state.pos_default,
            },
        }

        this.setState({ loading: true })
        api.get(api.getMyPageBlockEndpoint(), params).then((response) => {
            let layout = []

            for (let i = 0; i < response.data.positions.length; i++) {
                layout.push({
                    x: response.data.positions[i].x,
                    y: response.data.positions[i].y,
                    w:
                        response.data.positions[i].w <= 0
                            ? 5
                            : response.data.positions[i].w,
                    h:
                        response.data.positions[i].h <= 0
                            ? 5
                            : response.data.positions[i].h,
                    i: response.data.positions[i].uuid,
                    minW: 5,
                    minH: 5,
                })
            }

            //Add default for new blocks
            for (let b = 0; b < response.data.results.length; b++) {
                this['blockRef' + response.data.results[b].id] =
                    React.createRef()
                this['divBlockRef' + response.data.results[b].id] =
                    React.createRef()

                let isExisting = layout.find(
                    (lItem) => lItem.i === response.data.results[b].uuid
                )
                if (!isExisting) {
                    layout.push({
                        x: (b * 6) % 12,
                        y: 0,
                        w: 6,
                        h: 10,
                        i: response.data.results[b].uuid,
                        minW: 5,
                        minH: 5,
                    })
                }
            }

            this.setState({
                loading: false,
                layout,
                blocks: response.data.results,
                pagerBlocks: response.data.pager,
            })
        })
    }

    checkContract() {
        let api = this.props.kedo.api()
        api.get(api.getOwnActiveSubscriptionEndpoint()).then((response) => {
            if (!response.data.subscription && response.data.expired) {
                this.setState({ subscriptionExpired: true })
            }
        })
    }

    renderExpired() {
        return <ExpiredModal kedo={this.props.kedo} />
    }

    componentDidMount() {
        if (this.props.kedo.isContractAdmin()) {
            this.checkContract()
        }

        this.fetchMyPageBlocks()
        this.props.kedo.title().set(this.props.kedo.t('Dashboard'))
        document.addEventListener(
            'fullscreenchange',
            this.handleFullScreenChange
        )
    }

    getBlockHeader(block, dossier) {
        if (!block || (dossier && dossier.id)) {
            return ''
        }

        if (block.def_dossier_id) {
            return (
                <h4>
                    <a href={`/defdossier/${block.def_dossier_id}`}>
                        {this.props.kedo
                            .env()
                            .translateItem(block, 'mypageblock')}
                    </a>
                </h4>
            )
        }

        return (
            <h4>{this.props.kedo.env().translateItem(block, 'mypageblock')}</h4>
        )
    }

    renderMyPageBlock(item, kedo, enlarged) {
        let blockProps = {
            kedo: kedo,
            block: item,
            dashboard: true,
            onClose: this.hideBlock,
            ref: enlarged === false ? this['blockRef' + item.id] : null,
            onSuccess: this.saveAndRefresh,
            getBlockHeader: this.getBlockHeader,
            onMax: (uuid) => this.setState({ expandBlock: uuid }),
        }

        switch (item.type) {
            case 'block_container':
                return <BlockContainerDisplay {...blockProps} />
            case 'dashboard':
                return <BlockDisplay {...blockProps} />
            case 'count_list_options':
                return <CountListBlock {...blockProps} />
            case 'list_option_percentage_conditions':
                return <PercentageMatchingBlock {...blockProps} />
            case 'count_link_options':
                return <CountLinkBlock {...blockProps} />
            case 'sum_fields':
                return <SumFieldsBlock {...blockProps} />
            case 'new_dossier_statistics':
                return <DateStatisticsBlock {...blockProps} />
            case 'active_users':
                return <UserMostActiveStatisticsBlock {...blockProps} />
            case 'online_users':
                return <UserStatisticsBlock {...blockProps} />
            case 'date_statistics':
                return <DateStatisticsBlock {...blockProps} />
            case 'geomap':
                return <BlockGeomap {...blockProps} />
            case 'funnel':
                return <FunnelBlock {...blockProps} />
            case 'kedo_charts':
                return <SupersetBlock {...blockProps} />
        }

        return ''
    }

    onLayoutChange(layout) {
        this.setState(
            {
                layout: layout,
            },
            this.state.toggleDrag ? this.submitPositions : null
        )
    }

    submitPositions() {
        let api = this.props.kedo.api()
        let envId = this.props.kedo.env().getEnvironment().id
        let payload = []
        for (let i = 0; i < this.state.layout.length; i++) {
            payload.push({
                block: this.state.layout[i].i,
                xPos: this.state.layout[i].x,
                yPos: this.state.layout[i].y,
                blockWidth: this.state.layout[i].w,
                blockHeight: this.state.layout[i].h,
            })
        }

        let dataPayload = { blocks: payload }

        if (this.state.pos_default === true) {
            dataPayload.default = true
        }

        this.setState({ savingPos: true })
        api.patch('/mypage/' + envId + '/position', dataPayload).then(
            (response) => this.setState({ savingPos: false })
        )
    }

    setAndGetDefaultPositions() {
        let api = this.props.kedo.api()
        let envId = this.props.kedo.env().getEnvironment().id

        this.setState(
            {
                loading: true,
            },
            () => {
                let params = { params: {} }
                if (this.state.pos_default) {
                    params.params.default = true
                }

                api.get('/mypage/' + envId + '/position', params).then(
                    (response) => {
                        let layout = []

                        for (let i = 0; i < response.data.length; i++) {
                            layout.push({
                                x: response.data[i].x,
                                y: response.data[i].y,
                                w:
                                    response.data[i].w <= 0
                                        ? 5
                                        : response.data[i].w,
                                h:
                                    response.data[i].h <= 0
                                        ? 5
                                        : response.data[i].h,
                                i: response.data[i].uuid,
                                minW: 5,
                                minH: 5,
                            })
                        }

                        this.setState({ loading: false, layout: layout })
                    }
                )
            }
        )
    }

    updateData(dataName, dataVal) {
        this.setState({ [dataName]: dataVal })
    }

    changeRefreshRate(eventKey) {
        if (this.state.refreshInt) {
            clearInterval(this.state.refreshInt)
        }

        let defRefRate = 30 * 60 * 1000

        if (eventKey === 'minute') {
            defRefRate = 60000
        } else if (eventKey === 'five_minute') {
            defRefRate = 5 * 60 * 1000
        } else if (eventKey === 'fifteen_minute') {
            defRefRate = 15 * 60 * 1000
        } else if (eventKey === 'thirty_minute') {
            defRefRate = 30 * 60 * 1000
        }

        let refreshInt = setInterval(() => {
            this.state.blocks.map((blockItem) => {
                let blockRefId = 'blockRef' + blockItem.id
                if (
                    this[blockRefId] &&
                    this[blockRefId].current &&
                    this[blockRefId].current &&
                    this[blockRefId].current.fetchData
                ) {
                    /**
                     * Check if an element is in viewport
                     *
                     * @param {number} [offset]
                     * @returns {boolean}
                     */
                    let eOffset = 0
                    if (this[blockRefId].current.getParentRef) {
                        const eTop = this[blockRefId].current
                            .getParentRef()
                            .current.getBoundingClientRect().top
                        if (
                            eTop + eOffset >= 0 &&
                            eTop - eOffset <= window.innerHeight
                        ) {
                            this[blockRefId].current.fetchData(false)
                        }
                    }
                }
            })
        }, defRefRate)
        this.setState({
            refreshRate: eventKey,
            refreshInt: refreshInt,
        })
        this.closeMenus()
    }

    changeDateBlocks(eventKey) {
        this.setState({ dateFormat: eventKey }, () => {
            this.state.blocks.map((blockItem) => {
                let blockRefId = 'blockRef' + blockItem.id
                if (
                    this[blockRefId] &&
                    this[blockRefId].current &&
                    this[blockRefId].current.setFilterAndFetchData
                ) {
                    this[blockRefId].current.setFilterAndFetchData(
                        'dateFormat',
                        eventKey
                    )
                }
            })
        })
        this.closeMenus()
    }

    moodPresentation() {
        if (typeof this.state.openSidebar === 'undefined') {
            this.presentation = false
        } else {
            this.presentation = !this.state.openSidebar
        }

        this.isActivated = !this.state.isActivated
        this.setState({
            openSidebar: this.presentation,
            isActivated: this.isActivated,
        })
        this.props.onCloseSidebar(this.presentation)
    }

    componentWillUnmount() {
        clearInterval(this.state.refreshInt)
    }

    renderExpandedBlock(uuid) {
        let block = this.state.blocks.find((block) => block.uuid === uuid)
        const kedo = this.props.kedo
        let mHeight = window.innerHeight - 100

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'xl'}
                fullWidth
                title={''}
                onClose={() => this.setState({ expandBlock: null })}
                headerClose={() => this.setState({ expandBlock: null })}
                contentProps={{ dividers: true }}
                actions={
                    <>
                        <StyledButton
                            disabled={this.state.submitting}
                            onClick={this.submit}
                        >
                            {this.state.submitting ? <LoadingDefault /> : null}{' '}
                            {kedo.t('Yes')}
                        </StyledButton>
                        <StyledButton
                            disabled={this.state.submitting}
                            onClick={this.props.onClose}
                            color="secondary"
                        >
                            {kedo.t('No')}
                        </StyledButton>
                    </>
                }
            >
                <ReactToPrint content={() => this.otherSelector}>
                    <Stack direction="row" alignItems="stretch">
                        <PrintContextConsumer>
                            {({ handlePrint }) => (
                                <CompactButton dense onClick={handlePrint}>
                                    <FontAwesomeIcon icon={faPrint} />
                                </CompactButton>
                            )}
                        </PrintContextConsumer>
                        <CompactButton
                            dense
                            onClick={() => this.setState({ expandBlock: null })}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </CompactButton>
                    </Stack>

                    <div
                        style={{ height: mHeight, overflowY: 'scroll' }}
                        ref={(el) => (this.otherSelector = el)}
                    >
                        <style type="text/css" media="print">
                            {
                                '@\
                            @media print {\
                            @page { size: landscape; }\
                            }\
                            page { size: landscape; }\
                        '
                            }
                        </style>

                        {this.state.blockLoading === block.id ? (
                            <center>
                                <LoadingDefault />
                            </center>
                        ) : (
                            this.renderMyPageBlock(block, kedo, true)
                        )}
                    </div>
                </ReactToPrint>
            </AppDialog>
        )
    }

    handleToggle = () => {
        this.setState(
            (prevState) => ({
                toggleIcon: !prevState.toggleIcon,
                toggleDrag: !prevState.toggleDrag,
            }),
            () => {
                if (this.state.pos_default) {
                    this.setAndGetDefaultPositions()
                }
                this.revertHiddenBlocks()
            }
        )
    }

    render() {
        const { toggleIcon, refreshAnchor, dateAnchor } = this.state
        const kedo = this.props.kedo
        let hasTemplate =
            kedo.isAdminOrEnvironmentAdmin() && kedo.env().hasTemplate()

        if (this.state.loading) {
            return (
                <div className="mypage">
                    <LoadingPage />
                </div>
            )
        }

        return (
            <div className="mypage">
                {this.state.expandBlock
                    ? this.renderExpandedBlock(this.state.expandBlock)
                    : null}
                {this.state.newBlock ? (
                    <BlockForm
                        variant={'new'}
                        kedo={kedo}
                        onSuccess={() => {
                            this.fetchMyPageBlocks()
                            this.setState({ newBlock: false })
                        }}
                        onClose={() => this.setState({ newBlock: false })}
                    />
                ) : null}
                <ReactToPrint content={() => this.selector}>
                    <Grid container>
                        <Grid size={12}>
                            <Stack direction="row" alignItems="stretch">
                                {kedo.hasPermissionFor(
                                    'kedo.mypageblocks.create'
                                ) && (
                                    <Tooltip title={kedo.t('Add Block')} arrow>
                                        <StyledButton
                                            onClick={() =>
                                                this.setState({
                                                    newBlock: true,
                                                })
                                            }
                                            aria-label={kedo.t('Add Block')}
                                        >
                                            <FontAwesomeIcon
                                                icon={faSquareDashedCirclePlus}
                                            />
                                        </StyledButton>
                                    </Tooltip>
                                )}

                                <Tooltip
                                    title={kedo.t(
                                        this.state.isActivated
                                            ? 'Minimize'
                                            : 'Maximize'
                                    )}
                                    arrow
                                >
                                    <StyledButton
                                        onClick={() => {
                                            this.moodPresentation()
                                            this.presentfullScreen()
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faExpand} />
                                    </StyledButton>
                                </Tooltip>

                                <Tooltip
                                    title={kedo.t(
                                        this.state.refreshRate || 'Refresh'
                                    )}
                                    arrow
                                >
                                    <StyledButton
                                        endIcon={
                                            <FontAwesomeIcon
                                                icon={faCaretDown}
                                                size="sm"
                                            />
                                        }
                                        sx={{
                                            height: '40px',
                                            '& .MuiButton-endIcon svg ': {
                                                fontSize: '16px',
                                            },
                                        }}
                                        onClick={this.openRefreshMenu}
                                    >
                                        <FontAwesomeIcon icon={faTimer} />
                                    </StyledButton>
                                </Tooltip>

                                <Menu
                                    anchorEl={refreshAnchor}
                                    open={Boolean(refreshAnchor)}
                                    onClose={this.closeMenus}
                                >
                                    <MenuItem
                                        onClick={() =>
                                            this.changeRefreshRate(
                                                'thirty_minute'
                                            )
                                        }
                                    >
                                        {'30 ' + kedo.t('minutes')}
                                    </MenuItem>

                                    <MenuItem
                                        onClick={() =>
                                            this.changeRefreshRate(
                                                'fifteen_minute'
                                            )
                                        }
                                    >
                                        {'15 ' + kedo.t('minutes')}
                                    </MenuItem>

                                    <MenuItem
                                        onClick={() =>
                                            this.changeRefreshRate(
                                                'five_minute'
                                            )
                                        }
                                    >
                                        {'5 ' + kedo.t('minutes')}
                                    </MenuItem>

                                    <MenuItem
                                        onClick={() =>
                                            this.changeRefreshRate('minute')
                                        }
                                    >
                                        {'1 ' + kedo.t('minute')}
                                    </MenuItem>
                                </Menu>

                                <Tooltip
                                    title={kedo.t(
                                        this.state.dateFormat ||
                                            'Choose an option'
                                    )}
                                    arrow
                                >
                                    <StyledButton
                                        endIcon={
                                            <FontAwesomeIcon
                                                icon={faCaretDown}
                                                size="sm"
                                            />
                                        }
                                        sx={{
                                            height: '40px',
                                            '& .MuiButton-endIcon svg ': {
                                                fontSize: '16px',
                                            },
                                        }}
                                        onClick={this.openDateMenu}
                                    >
                                        <FontAwesomeIcon
                                            icon={faCalendarRange}
                                        />
                                    </StyledButton>
                                </Tooltip>

                                <Menu
                                    anchorEl={dateAnchor}
                                    open={Boolean(dateAnchor)}
                                    onClose={this.closeMenus}
                                >
                                    <MenuItem
                                        onClick={() =>
                                            this.changeDateBlocks('year_month')
                                        }
                                    >
                                        {kedo.t('year_month')}
                                    </MenuItem>

                                    <MenuItem
                                        onClick={() =>
                                            this.changeDateBlocks('quarter')
                                        }
                                    >
                                        {kedo.t('quarter')}
                                    </MenuItem>

                                    <MenuItem
                                        onClick={() =>
                                            this.changeDateBlocks('year')
                                        }
                                    >
                                        {kedo.t('year')}
                                    </MenuItem>
                                </Menu>

                                <PrintContextConsumer>
                                    {({ handlePrint }) => (
                                        <Tooltip title={kedo.t('Print')} arrow>
                                            <StyledButton onClick={handlePrint}>
                                                <FontAwesomeIcon
                                                    icon={faPrint}
                                                />
                                            </StyledButton>
                                        </Tooltip>
                                    )}
                                </PrintContextConsumer>

                                {this.state.hiddenBlocks.length > 0 && (
                                    <Tooltip title={kedo.t('Hidden')} arrow>
                                        <StyledButton
                                            onClick={() =>
                                                this.revertHiddenBlocks()
                                            }
                                        >
                                            <FontAwesomeIcon
                                                icon={faEyeSlash}
                                            />
                                        </StyledButton>
                                    </Tooltip>
                                )}

                                <Tooltip
                                    title={
                                        toggleIcon
                                            ? kedo.t('Drag is disabled')
                                            : kedo.t('Drag is enabled')
                                    }
                                    arrow
                                >
                                    <StyledButton onClick={this.handleToggle}>
                                        <FontAwesomeIcon
                                            icon={faToggleLargeOn}
                                            flip={
                                                toggleIcon
                                                    ? 'horizontal'
                                                    : 'vertical'
                                            }
                                            style={
                                                !toggleIcon
                                                    ? {
                                                          '--fa-primary-color':
                                                              '#000000',
                                                          '--fa-secondary-color':
                                                              '#03bd00',
                                                      }
                                                    : {}
                                            }
                                        />
                                    </StyledButton>
                                </Tooltip>

                                {kedo.isAdminOrEnvironmentAdmin() && (
                                    <Select
                                        size="small"
                                        value={
                                            this.state.pos_default
                                                ? 'default_view'
                                                : 'my_view'
                                        }
                                        onChange={(e) =>
                                            this.setState(
                                                {
                                                    pos_default:
                                                        e.target.value ===
                                                        'default_view',
                                                },
                                                this.setAndGetDefaultPositions
                                            )
                                        }
                                        sx={{
                                            backgroundColor: '#fff',
                                            borderRadius: '8px',
                                            boxShadow:
                                                '0px 2px 6px rgba(0,0,0,0.15)',
                                            '& .MuiOutlinedInput-notchedOutline':
                                                {
                                                    border: 'none',
                                                },
                                            '&:hover': {
                                                boxShadow:
                                                    '0px 4px 10px rgba(0,0,0,0.2)',
                                            },
                                        }}
                                    >
                                        <MenuItem value="default_view">
                                            {kedo.t('Default view')}
                                        </MenuItem>

                                        <MenuItem value="my_view">
                                            {kedo.t('My view')}
                                        </MenuItem>
                                    </Select>
                                )}
                            </Stack>
                        </Grid>
                    </Grid>
                    {this.state.subscriptionExpired
                        ? this.renderExpired()
                        : null}
                    {hasTemplate ? (
                        <TemplateInstall
                            kedo={kedo}
                            templateId={
                                kedo.env().getEnvironment().apply_template
                            }
                        />
                    ) : null}
                    {kedo.isAdminOrEnvironmentAdmin() &&
                    this.state.blocks.length > 0 ? (
                        <hr className={'statistics'} />
                    ) : null}
                    <ResponsiveReactGridLayout
                        ref={(el) => (this.selector = el)}
                        className={`layout ${this.state.grayedDateBlocks}`}
                        isDraggable={this.state.toggleDrag}
                        isResizable={this.state.toggleDrag}
                        rowHeight={25}
                        breakpoints={{
                            lg: 1200,
                            md: 996,
                            sm: 768,
                            xs: 480,
                            xxs: 0,
                        }}
                        cols={{ lg: 12, md: 12, sm: 12, xs: 6, xxs: 4 }}
                        onResizeStop={() => this.setState({ moved: true })}
                        onDragStop={() => this.setState({ moved: true })}
                        onLayoutChange={this.onLayoutChange}
                        layout={this.state.layout}
                    >
                        {this.state.blocks.length > 0
                            ? this.state.blocks.map((item) => {
                                  let showYScroll =
                                      item.settings?.show_y_scroll === 'yes'
                                          ? true
                                          : false
                                  let isDateFilteredBlock =
                                      (item.settings?.use_creation_date ||
                                          item.settings?.date_field) &&
                                      item.type !== 'date_statistics'

                                  return (
                                      <div
                                          key={item.uuid}
                                          className={`kedo-block d-print-block ${
                                              showYScroll === true
                                                  ? 'kedo-block-show-y'
                                                  : ''
                                          } ${
                                              isDateFilteredBlock
                                                  ? 'kedo-date-block'
                                                  : ''
                                          }`}
                                          data-grid={this.state.layout.find(
                                              (layoutItem) =>
                                                  layoutItem.i === item.uuid
                                          )}
                                      >
                                          <BlockLazy>
                                              {this.state.blockLoading ===
                                              item.id ? (
                                                  <center>
                                                      <LoadingDefault />
                                                  </center>
                                              ) : (
                                                  this.renderMyPageBlock(
                                                      item,
                                                      kedo,
                                                      false
                                                  )
                                              )}
                                          </BlockLazy>
                                      </div>
                                  )
                              })
                            : null}
                    </ResponsiveReactGridLayout>
                </ReactToPrint>
            </div>
        )
    }
}

export default MyPage
